module.exports = __webpack_public_path__ + "img/1504942990.a3cab565.jpg";